import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { map, Observable } from 'rxjs';
import { ControlSettings } from 'src/app/shared/controls/ControlSettings';
import { EmployeeSearchResultItem } from '../../models/EmployeeSearchResultItem';
import { EmployeeService } from '../../service/employee.service';

@Component({
  selector: 'app-employee-multiselect-ctrl',
  templateUrl: './employee-multiselect.component.html',
  styleUrls: ['./employee-multiselect.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: EmployeeMultiselectComponent,
    multi: true
  }]
})
export class EmployeeMultiselectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer,
    private employeeService: EmployeeService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  @Input() hasInspectionRoleAllowedFlag = false;
  @Input() hasEmployeeTechnicianAllowedFlag = false;
  @Input() hasAssemblyRoleAllowedFlag = false;
  @Input() hasEmployeeMeritoricAllowedFlag = false;
  @Input() hasPartsHandlingEmployeeAllowedFlag = false;
  @Input() hasTechnicianRoleAllowedFlag = false;

  @Input() hasEmployeeExpertTechnicianAllowedFlag = false;
  @Input() hasEmployeeExpertMeritoricAllowedFlag = false;

  @Output() valueChangeEvent = new EventEmitter<number>();
 
  employeesList$: Observable<EmployeeSearchResultItem[]>;
  filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
    fields: ['name', 'surname', 'position']
  };


  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    this.employeesList$ = this.employeeService.getAllEmployeesList().pipe(
      map( (x => x.filter(emp => 
        this.getUserForSpecificRole(emp)
      )) )
      );

  }

  getUserForSpecificRole(emp:EmployeeSearchResultItem) : boolean{
    const checkResult = 
    (!this.hasInspectionRoleAllowedFlag ||  emp.hasInspectionRoleAllowed ) &&
      (!this.hasTechnicianRoleAllowedFlag ||  emp.hasTechnicianRoleAllowed ) &&
      (!this.hasAssemblyRoleAllowedFlag ||  emp.hasAssemblyRoleAllowed ) &&
      (!this.hasEmployeeTechnicianAllowedFlag ||  emp.hasEmployeeTechnicianAllowed ) &&
      (!this.hasEmployeeMeritoricAllowedFlag ||  emp.hasEmployeeMeritoricAllowed ) &&
      (!this.hasEmployeeExpertTechnicianAllowedFlag ||  emp.hasEmployeeExpertTechnicianAllowed ) &&
      (!this.hasEmployeeExpertMeritoricAllowedFlag ||  emp.hasEmployeeExpertMeritoricAllowed ) &&
      (!this.hasPartsHandlingEmployeeAllowedFlag ||  emp.hasPartsHandlingEmployeeAllowed );

      return checkResult;
  }

  onChange(value: number) {
   
    // this.control.setValue(value);
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
